var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('v-select',{attrs:{"items":_vm.degreeChoices,"label":"Stopień naukowy"},model:{value:(_vm.degree),callback:function ($$v) {_vm.degree=$$v},expression:"degree"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }